import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M03_TOPICS, M03_MODULE_INFO, getAllM03Problems } from '../data/mathExercises/M03_SimultaneousLinearEquations';

const M03SimultaneousEquationsExercise = ({ onProgress }) => {
  const topics = M03_TOPICS;
  const problems = getAllM03Problems();
  const moduleInfo = M03_MODULE_INFO;

  return (
    <ExerciseInterface
      moduleInfo={moduleInfo}
      topics={topics}
      problems={problems}
      onProgress={onProgress}
      className="m03-exercise"
    />
  );
};

export default M03SimultaneousEquationsExercise; 